module.exports = __webpack_public_path__ + "media/images/pic/courses/01-de24dffd2b0a2e7ec5209e484a1ec377.svg";